module.exports = __webpack_public_path__ + "static/assets/999c2f2bd03a1e44366e1b3ec28ee61c.png";